import React from 'react'
import styled from 'styled-components'

import { media, rhythm } from '../utils/style-utils'

const TitleWrap = styled.h2`
  font-weight: 300;
  letter-spacing: 0.08em;
  text-align: center;
  line-height: 1.2;
  max-width: 15em;
  margin: 0 auto;
  text-transform: uppercase;
  font-size: 1.2rem;

  ${media.tablet`
    font-size: 2rem;
  `}

  ${media.desktop`
    font-size: 3rem;
  `}



  margin-top: ${props => (props.leader ? rhythm(5) : 0)};
  margin-bottom: ${props => (props.trailer ? rhythm(5) : 0)};
`

const SectionTitle = props => {
  const { children, leader, trailer } = props
  return (
    <TitleWrap leader={leader} trailer={trailer}>
      {children}
    </TitleWrap>
  )
}

export default SectionTitle



// WEBPACK FOOTER //
// ./src/components/SectionTitle.js